import { uppercaseFirstLetter } from './';

export const slugToComponentName = (slug) => {
  // remove all spaces and non-alphanumeric characters from slub
  // capitalize first letter of each word
  const slugParts = slug.split('-');
  return slugParts.map((part) => uppercaseFirstLetter(part)).join('');
};
